// import * as React from "react";
// import { useEffect } from "react";
// import { useOrganization } from "../../configurations/OrganizationContext";
// import Dymo from "dymojs";

// function SeparatePdf(props) {
//   const now = new Date();
//   const day = now.getDate();
//   const month = now.toLocaleString('default', { month: 'short' });
//   const year = now.getFullYear();
//   const suffix = getNumberWithSuffix(day);
//   const regpdfUrl = props.patientDetails.regFeesPdfUrl;
//   const formattedDate = `${suffix} ${month} ${year}`;
//   const qz = require("qz-tray");
//   const org = useOrganization();
  
//   let patientRegInfo = [];
//   let tokenDetails = [];
//   let barCodeDetails = [];
//   let numberOfPrints = 0;
//   let barCodeZPLCode;
//   let replacedBarcode = "";
//   let tokenZPLCode;
//   let replacedToken;
//   let replacedRegCardDetails;
//   let regCardZPLCode;
//   let dymoLabelXml = "";
  
//   const printerName = process.env.REACT_APP_PRINTER_NAME;

//   useEffect(() => {
//     console.log("Props in merge pdf is", props);
//     console.log("Organization ID:", org?.id);
//     formatData();
//     let age = props.tokenDetails.age > 0 ? props.tokenDetails.age : '';
//     let gender = props.tokenDetails.gender ? props.tokenDetails.gender : '';
//     let strPrintOption = props.printOption;
    
//     printerListenAndProcess(strPrintOption, age, gender);
//   }, []);

//   function replaceBarcode(zplCodeTemplate) {
//     const visitIdFrmProps = props.tokenDetails.visitId;
//     const uac13Code = padWithZeros(visitIdFrmProps, 13);
//     const strPatientId = props.patientDetails.id;

//     return zplCodeTemplate
//       .replace('{{ strPatientId }}', strPatientId)
//       .replace('{{ uac13Code}}', uac13Code);
//   }

//   function replaceRegCard(regCardZPLCode, patientDetails, age, gender) {
//     const dateFormat = new Date(patientDetails.registeredOn); 
//     const strAge = (patientDetails.age > 0 ? patientDetails.age : ' -');
//     const strGender = gender ? (gender == "Male" ? 'M' : 'F') : '-';
//     const strValidity = "*Card expires after 1yr of registration";
//     const strPatientName = `${patientDetails.fname} ${patientDetails.mname} ${patientDetails.lname}`;
//     const strCity = patientDetails.city;
//     const strPatientId = patientDetails.id;

//     const strDay = dateFormat.getDate();
//     const strMonth = dateFormat.toLocaleString('default', { month: 'short' });
//     const strYear = dateFormat.getFullYear();
//     const strSuffix = getNumberWithSuffix(strDay);
//     const formattedDate = `${strSuffix} ${strMonth} ${strYear}`;
    
//     return regCardZPLCode
//       .replace('{{strPatientName}}', strPatientName)
//       .replace('{{gender}}', strGender)
//       .replace('{{age}}', strAge)
//       .replace('{{strCity}}', strCity)
//       .replace('{{ strPatientId }}', strPatientId)
//       .replace('{{ formattedDate }}', formattedDate)
//       .replace('{{strValidity}}', strValidity);
//   }

//   function replaceTokenDetails(tokenZPLCode, age, gender) {
//     const strToken = (props.tokenDetails.tokenNumber ? props.tokenDetails.tokenNumber : ' -');
//     const strDeskNo = props.tokenDetails.deskNumber;
//     const strDeskAndToken = `${strDeskNo}-${strToken}`;
//     const strAge = (age ? age + "yrs" : ' -');
//     const strGender = (gender ? (gender == "Male" ? 'M' : 'F') : '-');
//     const strPatientName = `${props.patientDetails.fname} ${props.patientDetails.mname} ${props.patientDetails.lname}`;
//     const strCity = props.patientDetails.city;
//     const strPatientId = props.patientDetails.id;
//     const visitIdFrmProps = props.tokenDetails.visitId;
    
//     let strDocName = "";
//     let strCounName = "";
    
//     if (props.deskDetails[props.patientDetails.id]?.person?.first_name) {
//       strDocName = `Dr ${props.deskDetails[props.patientDetails.id].person.first_name} ${props.deskDetails[props.patientDetails.id].person.last_name}`;
//     }
    
//     if (props.deskDetails[props.patientDetails.id]?.counsellor?.first_name) {
//       strCounName = `Dr ${props.deskDetails[props.patientDetails.id].counsellor.first_name} ${props.deskDetails[props.patientDetails.id].counsellor.last_name}`;
//     }

//     return tokenZPLCode
//       .replace('{{strDeskAndToken}}', strDeskAndToken)
//       .replace('{{strDocName}}', strDocName)
//       .replace('{{strCounName}}', strCounName)
//       .replace('{{strPatientName}}', strPatientName)
//       .replace('{{strGender}}', strGender)
//       .replace('{{age}}', age)
//       .replace('{{strCity}}', strCity)
//       .replace('{{formattedDate}}', formattedDate)
//       .replace('{{strPatientId}}', strPatientId);
//   }

//   async function readZPLFile(filePath) {
//     const response = await fetch(filePath);
//     return await response.text();
//   }

//   async function readDymoFile(filePath) {
//     const response = await fetch(filePath);
//     return await response.text();
//   }

//   function replaceDymoTemplate(dymoXml, patientDetails, age, gender) {
//     const dateFormat = new Date(patientDetails.registeredOn);
//     const strAge = (patientDetails.age > 0 ? patientDetails.age : '');
//     const strGender = gender ? gender : '';
//     const strPatientName = `${patientDetails.fname} ${patientDetails.mname} ${patientDetails.lname}`;
//     const strCity = patientDetails.city;
//     const strPatientId = patientDetails.id;
//     const strMobile = patientDetails.mobile || props.patientDetails.phone || "+919456788866";

//     const strDay = dateFormat.getDate();
//     const strMonth = dateFormat.toLocaleString('default', { month: 'short' });
//     const strYear = dateFormat.getFullYear();
//     const strSuffix = getNumberWithSuffix(strDay);
//     const formattedDate = `${strSuffix} ${strMonth} ${strYear}`;
// console.log("dsdwsdewdewedqwedwewe",strPatientName,strPatientId,strGender,strAge,strCity,strMobile);
//     return dymoXml
//       .replace(/SUHANA MASOOD/g, strPatientName.toUpperCase())
//       .replace(/20576/g, strPatientId)
//       .replace(/Female/g, strGender)
//       .replace(/29/g, strAge)
//       .replace(/MANGALORE/g, strCity.toUpperCase())
//       .replace(/\+919456788866/g, strMobile);
//   }

//   async function fetchData(age, gender) {
//     try {
//       barCodeZPLCode = await readZPLFile('/static/barCodeTemplate.zpl');
//       replacedBarcode = replaceBarcode(barCodeZPLCode);

//       tokenZPLCode = await readZPLFile('/static/tokenCodeTemplate.zpl');
//       replacedToken = replaceTokenDetails(tokenZPLCode, age, gender);

//       // Load registration card template based on organization
//       if (org?.id === "2") {
//         // DYMO template for org 2
//         dymoLabelXml = await readDymoFile('/static/regiCard.label');
//         dymoLabelXml = replaceDymoTemplate(dymoLabelXml, props.patientDetails, age, gender);
//       } else {
//         // ZPL template for org 1 or others
//         regCardZPLCode = await readZPLFile('/static/regCardTemplate.zpl');
//         replacedRegCardDetails = replaceRegCard(regCardZPLCode, props.patientDetails, age, gender);
//       }
//     } catch (error) {
//       console.error('Error reading template files:', error);
//       throw error;
//     }
//   }

//   function getNumberWithSuffix(number) {
//     const suffixes = ["th", "st", "nd", "rd"];
//     const suffix = number % 100;
//     return number + (suffixes[(suffix - 20) % 10] || suffixes[suffix] || suffixes[0]);
//   }

//   const formatData = () => {
//     const deskString = props.tokenDetails.deskNumber;
//     const deskNo = deskString.replace(/\D/g, "");
//   };

//   function padWithZeros(number, width) {
//     const numberString = number.toString();
//     const zerosToAdd = Math.max(0, width - numberString.length);
//     return '0'.repeat(zerosToAdd) + numberString;
//   }

//   function createRegCard(patientDetails, age, gender, regCardZPLCode) {
//     const dateFormat = new Date(patientDetails.registeredOn);
//     const strAge = (patientDetails.age > 0 ? patientDetails.age + "yrs" : ' -');
//     const strGender = gender ? (gender == "Male" ? 'M' : 'F') : '-';
//     const strValidity = "*Card expires after 1yr of registration";
//     const strPatientName = `${patientDetails.fname} ${patientDetails.mname} ${patientDetails.lname}`;
//     const strCity = patientDetails.city;
//     const strPatientId = patientDetails.id;

//     const strDay = dateFormat.getDate();
//     const strMonth = dateFormat.toLocaleString('default', { month: 'short' });
//     const strYear = dateFormat.getFullYear();
//     const strSuffix = getNumberWithSuffix(strDay);
//     const formattedDate = `${strSuffix} ${strMonth} ${strYear}`;

//     patientRegInfo.push(replacedRegCardDetails);
//   }

//   function createToken(age, gender, tokenZPLCode) {
//     tokenDetails.push(replacedToken);
//   }

//   async function createBarCode() {
//     await fetchData();
//     barCodeDetails.push(replacedBarcode);
//   }

//   function createRegFeeReciept() {
//     qz.websocket.connect().then(() => {
//       const config = qz.configs.create(printerName, {
//         size: { width: 148, height: 210 }, 
//         units: 'mm',
//         scaleContent: false,
//       });
      
//       const data = [{
//         type: 'pdf',
//         data: regpdfUrl
//       }];

//       return qz.print(config, data);
//     }).catch(console.error);
//   }

//   async function printDymoRegCard(patientDetails, age, gender) {
//     try {
//       // Initialize DYMO framework
//       if (!Dymo.label.framework.isInitialized()) {
//         await Dymo.label.framework.init();
//       }

//       // Load label
//       const dymoLabel = Dymo.label.framework.openLabelXml(dymoLabelXml);
//       if (!dymoLabel) {
//         throw new Error("Failed to load DYMO label");
//       }

//       // Get printers
//       const printers = Dymo.label.framework.getPrinters();
//       if (!printers || printers.length === 0) {
//         throw new Error("No DYMO printers found");
//       }

//       // Select printer - you might want to make this configurable
//       const printerName = printers[0].name;
//       console.log("Printing to DYMO printer:", printerName);

//       // Print settings
//       const printParams = {
//         printerName: printerName,
//         printQuality: "Text",
//         copies: 1,
//         flowDirection: "LeftToRight"
//       };

//       // Print the label
//       await Dymo.label.framework.printLabel(printParams, dymoLabel);
//     } catch (error) {
//       console.error("DYMO printing error:", error);
//       throw error;
//     }
//   }

//   async function printerListenAndProcess(strPrintOption, age, gender) {
//     try {
//       await fetchData(age, gender);
      
//       if (strPrintOption.token) {
//         const patientIdFrmProps = props.tokenDetails.id;
//         if (props.deskDetails[patientIdFrmProps]?.person?.first_name?.length) {
//           createToken(age, gender, tokenZPLCode);
//           numberOfPrints++;
//         }
//       }
      
//       if (strPrintOption.idcard) {
//         if (org?.id === "2") {
//           await printDymoRegCard(props.patientDetails, age, gender);
//         } else {
//           createRegCard(props.patientDetails, age, gender, regCardZPLCode);
//         }
//         numberOfPrints++;
//       }
      
//       if (strPrintOption.barcode) {
//         createBarCode();
//         numberOfPrints++;
//       }

//       if (strPrintOption.receipt) {
//         numberOfPrints++;
//       }

//       if (numberOfPrints > 0) {
//         printAll(strPrintOption.token, strPrintOption.idcard, strPrintOption.barcode, strPrintOption.receipt);
//       } else {
//         props.onModalClose("could not print returning");
//       }
//     } catch (error) {
//       console.error("Printing process error:", error);
//       props.onModalClose("could not print returning");
//     }
//   }

//   function printAll(tokenCard, regCard, barCodeFormat, receipt) {
//     qz.websocket.connect().then(() => { 
//       return qz.printers.find("IMPACT by Honeywell IH-2 (ZPL)");
//     }).then((printer) => {
//       const config = qz.configs.create(printer);
      
//       const printOperations = [];
      
//       if (barCodeFormat) {
//         printOperations.push(
//           qz.print(config, barCodeDetails)
//             .then(() => decrementPrints())
//             .catch(handlePrintError)
//         );
//       }

//       if (tokenCard) {
//         printOperations.push(
//           qz.print(config, tokenDetails)
//             .then(() => decrementPrints())
//             .catch(handlePrintError)
//         );
//       }

//       if (regCard && org?.id !== "2") { // Only print reg card via ZPL if not org 2
//         printOperations.push(
//           qz.print(config, patientRegInfo)
//             .then(() => decrementPrints())
//             .catch(handlePrintError)
//         );
//       }

//       if (receipt) {
//         printOperations.push(
//           createRegFeeReciept()
//             .then(() => decrementPrints())
//             .catch(handlePrintError)
//         );
//       }

//       return Promise.all(printOperations);
//     }).catch((e) => {
//       console.error("connect failure", e);
//       props.onModalClose("could not print returning");
//     });

//     function decrementPrints() {
//       numberOfPrints--;
//       if (numberOfPrints === 0) {
//         qz.websocket.disconnect().then(() => {
//           props.onModalClose("printed successfully");
//         });
//       }
//     }

//     function handlePrintError(e) {
//       console.log("caught error");
//       decrementPrints();
//     }
//   }

//   return <></>;
// }

// export default SeparatePdf;


//--------------------

/* global DYMO */
import * as React from "react";
import PdfPrinter from "pdfmake";
import { useEffect, useState } from "react";
import { patientActions } from '../../core/actions';
import { useDispatch } from "react-redux";
import { useOrganization } from "../../configurations/OrganizationContext"

import {
ORG_CODES
} from "../../shared/constants";

// Remove the dymojs import - we'll use the global DYMO object loaded from the script
// import Dymo from "dymojs";

function SeparatePdf(props) {
  const now = new Date();
  const day = now.getDate();
  const month = now.toLocaleString('default', { month: 'short' });
  const year = now.getFullYear();
  const suffix = getNumberWithSuffix(day);
  const regpdfUrl = props.patientDetails.regFeesPdfUrl;
  const formattedDate = `${suffix} ${month} ${year}`;
  const qz = require("qz-tray");
  const org = useOrganization();
  
  let patientRegInfo = [];
  let tokenDetails = [];
  let barCodeDetails = [];
  let numberOfPrints = 0;
  let barCodeZPLCode;
  let replacedBarcode = "";
  let tokenZPLCode;
  let replacedToken;
  let replacedRegCardDetails;
  let regCardZPLCode;
  
  const printerName = process.env.REACT_APP_PRINTER_NAME;

  useEffect(() => {
    console.log("Props in merge pdf is", props);
    console.log("Organization ID:", org?.id);
    formatData();
    let age = props.tokenDetails.age > 0 ? props.tokenDetails.age : '';
    let gender = props.tokenDetails.gender ? props.tokenDetails.gender : '';
    let strPrintOption = props.printOption;
    
    printerListenAndProcess(strPrintOption, age, gender);
  }, []);

  function replaceBarcode(zplCodeTemplate) {
    const visitIdFrmProps = props.tokenDetails.visitId;
    const uac13Code = padWithZeros(visitIdFrmProps, 13);
    const strPatientId = props.patientDetails.id;

    return zplCodeTemplate
      .replace('{{ strPatientId }}', strPatientId)
      .replace('{{ uac13Code}}', uac13Code);
  }

  function replaceRegCard(regCardZPLCode, patientDetails, age, gender) {
    const dateFormat = new Date(patientDetails.registeredOn); 
    const strAge = (patientDetails.age > 0 ? patientDetails.age : ' -');
    const strGender = gender ? (gender == "Male" ? 'M' : 'F') : '-';
    const strValidity = "*Card expires after 1yr of registration";
    const strPatientName = `${patientDetails.fname} ${patientDetails.mname} ${patientDetails.lname}`;
    const strCity = patientDetails.city;
    const strPatientId = patientDetails.id;

    const strDay = dateFormat.getDate();
    const strMonth = dateFormat.toLocaleString('default', { month: 'short' });
    const strYear = dateFormat.getFullYear();
    const strSuffix = getNumberWithSuffix(strDay);
    const formattedDate = `${strSuffix} ${strMonth} ${strYear}`;
    
    return regCardZPLCode
      .replace('{{strPatientName}}', strPatientName)
      .replace('{{gender}}', strGender)
      .replace('{{age}}', strAge)
      .replace('{{strCity}}', strCity)
      .replace('{{ strPatientId }}', strPatientId)
      .replace('{{ formattedDate }}', formattedDate)
      .replace('{{strValidity}}', strValidity);
  }

  function replaceTokenDetails(tokenZPLCode, age, gender) {
    const strToken = (props.tokenDetails.tokenNumber ? props.tokenDetails.tokenNumber : ' -');
    const strDeskNo = props.tokenDetails.deskNumber;
    const strDeskAndToken = `${strDeskNo}-${strToken}`;
    const strAge = (age ? age + "yrs" : ' -');
    const strGender = (gender ? (gender == "Male" ? 'M' : 'F') : '-');
    const strPatientName = `${props.patientDetails.fname} ${props.patientDetails.mname} ${props.patientDetails.lname}`;
    const strCity = props.patientDetails.city;
    const strPatientId = props.patientDetails.id;
    const visitIdFrmProps = props.tokenDetails.visitId;
    
    let strDocName = "";
    let strCounName = "";
    
    if (props.deskDetails[props.patientDetails.id]?.person?.first_name) {
      strDocName = `Dr ${props.deskDetails[props.patientDetails.id].person.first_name} ${props.deskDetails[props.patientDetails.id].person.last_name}`;
    }
    
    if (props.deskDetails[props.patientDetails.id]?.counsellor?.first_name) {
      strCounName = `Dr ${props.deskDetails[props.patientDetails.id].counsellor.first_name} ${props.deskDetails[props.patientDetails.id].counsellor.last_name}`;
    }

    return tokenZPLCode
      .replace('{{strDeskAndToken}}', strDeskAndToken)
      .replace('{{strDocName}}', strDocName)
      .replace('{{strCounName}}', strCounName)
      .replace('{{strPatientName}}', strPatientName)
      .replace('{{strGender}}', strGender)
      .replace('{{age}}', age)
      .replace('{{strCity}}', strCity)
      .replace('{{formattedDate}}', formattedDate)
      .replace('{{strPatientId}}', strPatientId);
  }

  async function readZPLFile(filePath) {
    const response = await fetch(filePath);
    return await response.text();
  }

  // Load DYMO label template - same as in PrintFiles.js
  async function loadDymoLabelTemplate() {
    try {
      const response = await fetch('/static/regiCard.label');
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const labelXml = await response.text();
      return labelXml;
    } catch (error) {
      console.error("Failed to load DYMO label template:", error);
      throw new Error("Could not load the ID card template file.");
    }
  }

  async function fetchData(age, gender) {
    try {
      barCodeZPLCode = await readZPLFile('/static/barCodeTemplate.zpl');
      replacedBarcode = replaceBarcode(barCodeZPLCode);

      tokenZPLCode = await readZPLFile('/static/tokenCodeTemplate.zpl');
      replacedToken = replaceTokenDetails(tokenZPLCode, age, gender);

      // Load registration card template based on organization
      if (org?.orgCode !== ORG_CODES.MNH) {
        // ZPL template for org 1 or others (not MNH)
        regCardZPLCode = await readZPLFile('/static/regCardTemplate.zpl');
        replacedRegCardDetails = replaceRegCard(regCardZPLCode, props.patientDetails, age, gender);
      }
      // For org 2 (MNH), we'll load DYMO template in the print function itself
    } catch (error) {
      console.error('Error reading template files:', error);
      throw error;
    }
  }

  function getNumberWithSuffix(number) {
    const suffixes = ["th", "st", "nd", "rd"];
    const suffix = number % 100;
    return number + (suffixes[(suffix - 20) % 10] || suffixes[suffix] || suffixes[0]);
  }

  const formatData = () => {
    const deskString = props.tokenDetails.deskNumber;
    const deskNo = deskString.replace(/\D/g, "");
  };

  function padWithZeros(number, width) {
    const numberString = number.toString();
    const zerosToAdd = Math.max(0, width - numberString.length);
    return '0'.repeat(zerosToAdd) + numberString;
  }

  function createRegCard(patientDetails, age, gender, regCardZPLCode) {
    const dateFormat = new Date(patientDetails.registeredOn);
    const strAge = (patientDetails.age > 0 ? patientDetails.age + "yrs" : ' -');
    const strGender = gender ? (gender == "Male" ? 'M' : 'F') : '-';
    const strValidity = "*Card expires after 1yr of registration";
    const strPatientName = `${patientDetails.fname} ${patientDetails.mname} ${patientDetails.lname}`;
    const strCity = patientDetails.city;
    const strPatientId = patientDetails.id;

    const strDay = dateFormat.getDate();
    const strMonth = dateFormat.toLocaleString('default', { month: 'short' });
    const strYear = dateFormat.getFullYear();
    const strSuffix = getNumberWithSuffix(strDay);
    const formattedDate = `${strSuffix} ${strMonth} ${strYear}`;

    patientRegInfo.push(replacedRegCardDetails);
  }

  function createToken(age, gender, tokenZPLCode) {
    tokenDetails.push(replacedToken);
  }

  async function createBarCode() {
    // Don't call fetchData again here, it's already called in printerListenAndProcess
    barCodeDetails.push(replacedBarcode);
  }

  function createRegFeeReciept() {
    return qz.websocket.connect().then(() => {
      const config = qz.configs.create(printerName, {
        size: { width: 148, height: 210 }, 
        units: 'mm',
        scaleContent: false,
      });
      
      const data = [{
        type: 'pdf',
        data: regpdfUrl
      }];

      return qz.print(config, data);
    }).catch(console.error);
  }

  // Fixed DYMO printing function - similar to PrintFiles.js
  async function printDymoRegCard(patientDetails) {
    // Check if DYMO framework is loaded and available
    if (typeof DYMO === 'undefined' || !DYMO.Label || !DYMO.Label.Framework) {
      const errorMsg = "DYMO Label Framework not loaded. Please check if the script is loaded in index.html";
      console.error(errorMsg);
      alert(errorMsg);
      throw new Error(errorMsg);
    }

    try {
      console.log("Starting DYMO print process for LabelWriter 450...");

      const labelXml = await loadDymoLabelTemplate();
      const label = DYMO.Label.Framework.openLabelXml(labelXml);
      
      if (!label) {
        throw new Error("Failed to parse the label template.");
      }

      // Set patient data - use exact object names from your DYMO template
      label.setObjectText("PatientName", `${patientDetails.fname} ${patientDetails.lname}`.trim());
      label.setObjectText("PatientId", patientDetails.id || '');
      label.setObjectText("Gender", patientDetails.gender || '');
      label.setObjectText("Age", (patientDetails.age ? patientDetails.age + ' Yrs' : ''));
      label.setObjectText("Address", patientDetails.address || patientDetails.city || '');
      label.setObjectText("MobileNo_1", patientDetails.phno || patientDetails.mobile || '');

      // Get available printers
      const printers = DYMO.Label.Framework.getPrinters();
      console.log("Available printers:", printers);

      if (!printers || printers.length === 0) {
        throw new Error("No printers found. Please ensure the DYMO LabelWriter 450 is connected and turned on.");
      }

      // Find the LabelWriter 450 printer
      let printerName = "";
      const dymoPrinter = printers.find(printer => 
        printer.name.includes("LabelWriter 450")
      );

      if (dymoPrinter) {
        printerName = dymoPrinter.name;
        console.log("Found specific printer:", printerName);
      } else {
        // Fallback: try to find any LabelWriter printer
        const genericLabelWriter = printers.find(printer => 
          printer.printerType === "LabelWriterPrinter"
        );
        if (genericLabelWriter) {
          printerName = genericLabelWriter.name;
          console.log("Specific LabelWriter 450 not found, using:", printerName);
        } else {
          // Final fallback: use the first printer in the list
          printerName = printers[0].name;
          console.warn("No LabelWriter found, defaulting to first available printer:", printerName);
        }
      }

      // Print the label
      DYMO.Label.Framework.printLabel(printerName, null, labelXml);
      console.log("Print command sent successfully to printer:", printerName);

    } catch (error) {
      console.error("Error in printDymoRegCard:", error);
      alert("Failed to print ID card: " + error.message);
      throw error;
    }
  }

  async function printerListenAndProcess(strPrintOption, age, gender) {
    try {
      await fetchData(age, gender);
      
      if (strPrintOption.token) {
        const patientIdFrmProps = props.tokenDetails.id;
        if (props.deskDetails[patientIdFrmProps]?.person?.first_name?.length) {
          createToken(age, gender, tokenZPLCode);
          numberOfPrints++;
        }
      }
      
      if (strPrintOption.idcard) {
        if (org?.orgCode === ORG_CODES.MNH) {
          // For MNH, print using DYMO
          await printDymoRegCard(props.patientDetails);
        } else {
          // For other organizations, use ZPL
          createRegCard(props.patientDetails, age, gender, regCardZPLCode);
        }
        numberOfPrints++;
      }
      
      if (strPrintOption.barcode) {
        await createBarCode();
        numberOfPrints++;
      }

      if (strPrintOption.receipt) {
        numberOfPrints++;
      }

      if (numberOfPrints > 0) {
        printAll(strPrintOption.token, strPrintOption.idcard, strPrintOption.barcode, strPrintOption.receipt);
      } else {
        props.onModalClose("could not print returning");
      }
    } catch (error) {
      console.error("Printing process error:", error);
      props.onModalClose("Printing failed: " + error.message);
    }
  }

  function printAll(tokenCard, regCard, barCodeFormat, receipt) {
    qz.websocket.connect().then(() => { 
      return qz.printers.find("IMPACT by Honeywell IH-2 (ZPL)");
    }).then((printer) => {
      const config = qz.configs.create(printer);
      
      const printOperations = [];
      
      if (barCodeFormat) {
        printOperations.push(
          qz.print(config, barCodeDetails)
            .then(() => decrementPrints())
            .catch(handlePrintError)
        );
      }

      if (tokenCard) {
        printOperations.push(
          qz.print(config, tokenDetails)
            .then(() => decrementPrints())
            .catch(handlePrintError)
        );
      }

      if (regCard && org?.orgCode !== ORG_CODES.MNH) { // Only print reg card via ZPL if not MNH (org 2)
        printOperations.push(
          qz.print(config, patientRegInfo)
            .then(() => decrementPrints())
            .catch(handlePrintError)
        );
      }

      if (receipt) {
        printOperations.push(
          createRegFeeReciept()
            .then(() => decrementPrints())
            .catch(handlePrintError)
        );
      }

      return Promise.all(printOperations);
    }).catch((e) => {
      console.error("connect failure", e);
      props.onModalClose("could not print returning");
    });

    function decrementPrints() {
      numberOfPrints--;
      if (numberOfPrints === 0) {
        qz.websocket.disconnect().then(() => {
          props.onModalClose("printed successfully");
        });
      }
    }

    function handlePrintError(e) {
      console.error("Print error:", e);
      decrementPrints();
    }
  }

  return <></>;
}

export default SeparatePdf;